import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ChallengeType } from 'app/types/graphql';
import caloriesIcon from 'app/assets/challenges-types/calories.svg';
import distanceIcon from 'app/assets/challenges-types/distance.svg';
import repsIcon from 'app/assets/challenges-types/reps.svg';
import timeIcon from 'app/assets/duration-icon.svg';
import weightIcon from 'app/assets/challenges-types/weight.svg';

export const useChallengeTypeIcon = (challengeType?: ChallengeType | null) => {
  const intl = useIntl();

  return useMemo(() => {
    if (!challengeType) {
      return null;
    }

    const iconMap: Record<ChallengeType, string> = {
      [ChallengeType.CALORIES]: caloriesIcon,
      [ChallengeType.DISTANCE]: distanceIcon,
      [ChallengeType.REPS]: repsIcon,
      [ChallengeType.TIME]: timeIcon,
      [ChallengeType.WEIGHT]: weightIcon,
    };

    const iconSrc = iconMap[challengeType];
    if (!iconSrc) {
      return null;
    }

    const challengeTypeKey = challengeType.toLowerCase();
    const altText = intl.formatMessage({ id: `challenges.type.${challengeTypeKey}` });
    const text = intl.formatMessage({ id: 'challenges.type.for' }, { type: altText });

    const icon = <img src={iconSrc} alt={altText} />;

    return {
      icon,
      text,
    };
  }, [challengeType, intl]);
};
